export function encodeCheckoutToken(agreementAddress: string, customerWallet: string): string {
  const a = agreementAddress.trim();
  const c = customerWallet.trim();
  const payload = JSON.stringify({ a, c, ts: Date.now() });

  if (typeof window !== "undefined") {
    return "chk_live_" + btoa(payload).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
  }
  return "chk_live_" + Buffer.from(payload).toString("base64url");
}

export function decodeCheckoutToken(token: string): { agreementAddress: string; customerWallet: string } | null {
  try {
    const raw = token.startsWith("chk_live_")
      ? token.slice(9)
      : token.startsWith("chk_")
      ? token.slice(4)
      : token;

    let jsonStr = "";
    if (typeof window !== "undefined") {
      jsonStr = atob(raw.replace(/-/g, "+").replace(/_/g, "/"));
    } else {
      jsonStr = Buffer.from(raw, "base64url").toString("utf8");
    }

    const parsed = JSON.parse(jsonStr);
    if (parsed && typeof parsed === "object" && parsed.a && parsed.c) {
      return {
        agreementAddress: parsed.a,
        customerWallet: parsed.c,
      };
    }
    return null;
  } catch {
    return null;
  }
}
